import { RenderSelectInput, RenderTextInput } from "app/common/renderInput";
import { Button } from "react-bootstrap";
import { IoMdCloseCircle } from "react-icons/io";
import { NotificationManager } from "react-notifications";

export default function GuestDetails({
  values,
  handleChange,
  errors,
  handleBlur,
  touched,
  setFieldValue,
  setState,
}) {
  const handleAddTraveller = (values, setFieldValue, roomIndex) => {
    const updatedRoomDetails = [...values.roomDetails];
    const updatedRoomInfo = [...values.roomInfo];
    debugger;
    // if (
    //   updatedRoomInfo[roomIndex].numberOfAdults >
    //     updatedRoomDetails[roomIndex].adt ||
    //   updatedRoomInfo[roomIndex].numberOfChild >
    //     updatedRoomDetails[roomIndex].chd
    // ) {
    const newTraveller = {
      ti: "Mr",
      pt: "ADULT",
      fN: "",
      lN: "",
      pNum: "",
      pan: "",
    };

    updatedRoomDetails[roomIndex] = {
      ...updatedRoomDetails[roomIndex],
      adt: updatedRoomInfo[roomIndex].numberOfAdults,
      chd: updatedRoomInfo[roomIndex].numberOfChild,
    };
    updatedRoomDetails[roomIndex].ti.push({ ...newTraveller });
    // Optional: If using Formik, update field value
    setFieldValue("roomDetails", updatedRoomDetails);

    // Also update local state if needed
    setState((prev) => ({
      ...prev,
      roomDetails: updatedRoomDetails,
    }));
    // } else {
    //   NotificationManager.warning("Mismatch in adult count with Room Details.");
    // }
  };
  const handleDeleteTraveller = (
    values,
    setFieldValue,
    roomIndex,
    travellerIndex
  ) => {
    const updatedRoomDetails = [...values.roomDetails];
    const updatedRoomInfo = [...values.roomInfo];
    // Check to prevent deleting the last traveller or out-of-bounds access
    if (updatedRoomDetails[roomIndex].ti.length > 1) {
      debugger;
      updatedRoomDetails[roomIndex] = {
        ...updatedRoomDetails[roomIndex],
        adt: updatedRoomInfo[roomIndex].numberOfAdults,
        chd: updatedRoomInfo[roomIndex].numberOfChild,
      };
      updatedRoomDetails[roomIndex].ti.splice(travellerIndex, 1);

      // Update Formik field value
      setFieldValue("roomDetails", updatedRoomDetails);

      // Optional: Update local state if you maintain one
      setState((prev) => ({
        ...prev,
        roomDetails: updatedRoomDetails,
      }));
    }
  };

  const titleList = [
    { value: "Mr", label: "Mr" },
    { value: "Mrs", label: "Mrs" },
    { value: "Ms", label: "Ms" },
    { value: "Master", label: "Master" },
  ];
  const guestTypeList = [
    { value: "ADULT", label: "Adult" },
    { value: "CHILD", label: "Child" },
  ];
  return (
    <div>
      {values.roomDetails.map((seg, index) => (
        <div key={index} className="border border-primary rounded p-2 mt-2">
          <div className="row mb-4">
            <div className="">
              <h4 className="mb-0">Room - {index + 1}</h4>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 mb-3">
              <RenderTextInput
                type="text"
                display={"Room Type"}
                className="form-control customInput"
                placeholder="Enter Room Type"
                name={`roomDetails[${index}].rc`}
                value={values?.roomDetails[index]?.rc || ""}
                onChange={handleChange}
                error={errors?.roomDetails?.[index]?.rc}
                touched={touched?.roomDetails?.[index]?.rc}
                onBlur={handleBlur}
              />
            </div>
            <div className="col-md-4 mb-3">
              <RenderTextInput
                display={"Inclusion"}
                type="text"
                className="form-control customInput"
                placeholder="Enter Inclusion"
                name={`roomDetails[${index}].mb`}
                value={values?.roomDetails?.[index]?.mb || ""}
                onChange={handleChange}
                error={errors?.roomDetails?.[index]?.mb}
                touched={touched?.roomDetails?.[index]?.mb}
                onBlur={handleBlur}
              />
            </div>
            <div className="col-md-4 mb-3">
              <RenderTextInput
                display={"Benefits(Comma Separated Eg. Free WiFi,Breakfast)"}
                name={`roomDetails[${index}].rexb`}
                value={values?.roomDetails?.[index]?.rexb || ""}
                onChange={handleChange}
                error={errors?.roomDetails?.[index]?.rexb}
                touched={touched?.roomDetails?.[index]?.rexb}
                onBlur={handleBlur}
                className="form-control customInput"
                placeholder="Enter benefits"
              />
            </div>
          </div>
          <div>
            <div>
              {Array.isArray(seg?.ti) &&
                seg?.ti?.map((segPax, id) => (
                  <div className="border rounded p-2 mt-2" key={id}>
                    <div className="row mb-4">
                      <div className="col-6">
                        <h4 className="mb-0 text-primary">Guest - {id + 1}</h4>
                      </div>
                      {id != 0 && (
                        <div className="col-6 ">
                          <div className="d-flex justify-content-end ">
                            <IoMdCloseCircle
                              size={25}
                              className="cursor-pointer text-danger"
                              onClick={() => {
                                handleDeleteTraveller(
                                  values,
                                  setFieldValue,
                                  index,
                                  id
                                );
                              }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="row">
                      <div className="col-md-2 ">
                        <RenderSelectInput
                          className="form-select customInput"
                          name={`roomDetails[${index}].ti[${id}].pt`}
                          placeholder="Guest Type"
                          value={values.roomDetails?.[index]?.ti?.[id]?.pt}
                          items={guestTypeList}
                          error={errors.roomDetails?.[index]?.ti?.[id]?.pt}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.roomDetails?.[index]?.ti?.[id]?.pt}
                          display={"Guest Type"}
                          required
                        ></RenderSelectInput>
                      </div>
                      <div className="col-md-2  ">
                        <RenderSelectInput
                          className="form-select customInput"
                          name={`roomDetails[${index}].ti[${id}].ti`}
                          placeholder="Title"
                          value={values?.roomDetails?.[index]?.ti?.[id]?.ti}
                          items={titleList}
                          error={errors?.roomDetails?.[index]?.ti?.[id]?.ti}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched?.roomDetails?.[index]?.ti?.[id]?.ti}
                          display={"Title"}
                          required
                        ></RenderSelectInput>
                      </div>

                      <div className="col-md-2  ">
                        <RenderTextInput
                          type="text"
                          className="form-control customInput"
                          placeholder="Enter First Name"
                          name={`roomDetails[${index}].ti[${id}].fN`}
                          value={values?.roomDetails?.[index]?.ti?.[id]?.fN}
                          onChange={handleChange}
                          error={errors?.roomDetails?.[index]?.ti?.[id]?.fN}
                          touched={touched?.roomDetails?.[index]?.ti?.[id]?.fN}
                          onBlur={handleBlur}
                          display={"First Name"}
                          required
                        />
                      </div>
                      <div className="col-md-2 ">
                        <RenderTextInput
                          type="text"
                          className="form-control customInput"
                          placeholder="Enter Last Name"
                          name={`roomDetails[${index}].ti[${id}].lN`}
                          value={values?.roomDetails?.[index]?.ti?.[id]?.lN}
                          onChange={handleChange}
                          error={errors?.roomDetails?.[index]?.ti?.[id]?.lN}
                          touched={touched?.roomDetails?.[index]?.ti?.[id]?.lN}
                          onBlur={handleBlur}
                          display={"Last Name"}
                          required
                        />
                      </div>
                      <div className="col-md-2 ">
                        <RenderTextInput
                          type="text"
                          className="form-control customInput"
                          placeholder="Enter Last Name"
                          name={`roomDetails[${index}].ti[${id}].pan`}
                          value={values?.roomDetails?.[index]?.ti?.[id]?.pan}
                          onChange={handleChange}
                          error={errors?.roomDetails?.[index]?.ti?.[id]?.pan}
                          touched={touched?.roomDetails?.[index]?.ti?.[id]?.pan}
                          onBlur={handleBlur}
                          display={"Pan Number"}
                        />
                      </div>
                      <div className="col-md-2">
                        <RenderTextInput
                          type="text"
                          className="form-control customInput"
                          placeholder="Enter Last Name"
                          name={`roomDetails[${index}].ti[${id}].pNum`}
                          value={values?.roomDetails?.[index]?.ti?.[id]?.pNum}
                          onChange={handleChange}
                          error={errors?.roomDetails?.[index]?.ti?.[id]?.pNum}
                          touched={
                            touched?.roomDetails?.[index]?.ti?.[id]?.pNum
                          }
                          onBlur={handleBlur}
                          display={"Passport Number"}
                        />
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
          <div className="row mt-2">
            <div
              style={{
                justifyContent: "flex-end",
                display: "flex",
              }}
            >
              <Button
                disabled={seg.adt + seg.chd > seg?.ti.length ? false : true}
                onClick={() => handleAddTraveller(values, setFieldValue, index)}
              >
                Add Guest
              </Button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
